<template>
  <div class="m-auto max-w-2xl">
    <p class="mb-6 text-center font-Playfair text-2xl" data-testid="thankyou">Thank you!</p>
    <div class="mx-auto mb-6 flex w-full items-center justify-center bg-beige1 px-4 py-8">
      <p class="text-center font-Spectral text-base tracking-normal text-black2">We will be in touch with you within 4 business days.<br /></p>
    </div>
    <p class="text-center font-Spectral text-sm tracking-normal text-black2">
      If you don't receive an email from us ({{ EMAIL_WABUNKA_GCS }}) by then,<br />please reach out or check your spam folder.
    </p>
  </div>
</template>

<script lang="ts" setup>
import { EMAIL_WABUNKA_GCS } from '@/wabunka-src/constants/companyInfo';
</script>
